import en from "./locales/en";
import nl from "./locales/nl";
import mailEn from "./locales/mail/en";
import mailNl from "./locales/mail/nl";
export default () => {
	return { messages: {
		en: {
			...en,
			...mailEn
		},
		nl: {
			...nl,
			...mailNl
		}
	} };
};
